import React from 'react';
import { useIntl } from 'react-intl';
import { Table } from 'semantic-ui-react';
import NameCell from '@/components/table/NameCell';
import {
  columnName, columnTools, columnValidationDate, hasColumn,
} from '@/constants/fields';
import { validationStatusIconProps } from '../helper';
import DataManagementValidationDateCell from './DataManagementValidationDateCell';
import DataManagementDataModelActionsCell from './DataManagementDataModelActionsCell';
import DataManagementDataModelToolsMenu from './DataManagementDataModelToolsMenu';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import ReportsEvents from '../../reports/hooks/events';

const DataManagementDataModelTableRow = ({
  category,
  code,
  columns,
}) => {
  const intl = useIntl();
  const {
    disableValidate,
    isLoading,
    lastValidationDate,
    name,
    valid,
  } = Selectors.useDataManagementDataModelItem(category, code);
  const validate = Events.useValidateDatasetData(category, { code });
  const showReports = ReportsEvents.useShowDataModelReports(category, { code });

  return (
    <Table.Row>
      {hasColumn(columns, columnName) && (
        <NameCell
          name={intl.formatMessage({ id: 'dataset.data.datamodel.reports.for' }, { name })}
          icon={validationStatusIconProps(valid).name}
          iconColour={validationStatusIconProps(valid).colour}
          message={validationStatusIconProps(valid).message}
          loading={isLoading}
          className="data-management-data-model-name"
        />
      )}
      {hasColumn(columns, columnValidationDate) && (
        <DataManagementValidationDateCell lastValidationDate={lastValidationDate} />
      )}
      {hasColumn(columns, columnTools) && (
        <>
          <DataManagementDataModelActionsCell
            category={category}
            code={code}
            disableValidate={disableValidate}
            isLoading={isLoading}
            validate={validate}
          />
          <Table.Cell collapsing>
            <DataManagementDataModelToolsMenu
              disableValidate={disableValidate || isLoading}
              name={name}
              showReports={showReports}
              validate={validate}
            />
          </Table.Cell>
        </>
      )}
    </Table.Row>
  );
};

export default DataManagementDataModelTableRow;
